<template>
  <div>
    <!--<navTitle title="开奖记录"></navTitle>-->
    <!--<navTitle-->
      <!--:title="-->
        <!--$router.app._route.query.ti ? $router.app._route.query.ti : 'Prize opening record'-->
      <!--"-->
      <!--path="/user"-->

    <!--&gt;</navTitle>-->

    <!--<gameTable :list="list"></gameTable>-->
    <div class="list">
      <div class="top">
        <div class="navitem">Opening time</div>
        <div class="navitem">Issue</div>
        <div class="navitem">Number</div>
        <div class="navitem">Results</div>
      </div>

      <div class="live">
        <div class="ul" v-for="item in list">
          <div class="li">{{ item.time }}</div>
          <div class="li">{{ item.serial }}</div>
          <div class="li">{{ item.number }}</div>
          <div class="li">
            <span>{{ item.result }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navTitle from "@components/navTitle";
import { guessOddList } from "@api/game";
import gameTable from "@components/GameTable";

export default {
  name: "rank",
  components: {
    navTitle,
    gameTable
  },
  data: function() {
    return {
      list: []
    };
  },
  watch: {
    $route(n) {
      if (n.name === "rank") {
        this.list = [];
        this.id = n.query.game_id || 24;
        this.getList();
      }
    }
  },
  methods: {
    getList() {
      this.$dialog.loading.open("loading...");
      guessOddList({
        page: 1,
        limit: 50,
        type: this.$route.query.game_id ||24
      })
        .then(res => {
          this.$dialog.loading.close();
          // console.log('list',res)
          this.list = res.data;
          let num_array = [];
          res.data.forEach((item, index) => {
            num_array.push(item.result_value);
          });
        })
        .catch(res => {
          this.$dialog.loading.close();
        });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped>
.list {
  width: 100%;
  margin: 0;
  position: relative;
  padding-top: 0.8rem;
}
.list .top {
  width: 100%;
  height: 0.8rem;
  line-height: 0.8rem;
  display: flex;
  background: #00c3f9;
  position: fixed;
  top: 0rem;
  left: 0px;
  z-index: 100;
}
.list .top .navitem {
  width: 25%;
  color: #fff;
  position: relative;
  text-align: center;
}
.list .top .navitem::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 50%;
  background: #fff;
}
.list .top .navitem:first-child:before {
  content: "";
  background: none;
}
.live {
  width: 100%;
  background: #fff;
}
.live .ul {
  width: 100%;
  height: 0.75rem;
  display: flex;
  border-bottom: 1px solid #f0f0f0;
  line-height: 0.75rem;
  color: #333;
}
.live .li {
  width: 25%;
  text-align: center;
}
.live .li span {
  width: 1.6rem;
  height: 0.5rem;
  line-height: 0.5rem;
  margin: 0.12rem auto;
  /*padding: 0.1rem 0px;*/
  text-align: center;
  display: block;
  border-radius: 0.05rem;
  background: #ffd52e;
  color: #6a4c14;
}
</style>
